var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pkb-footer" }, [
    _c(
      "div",
      { staticClass: "menu" },
      [
        _c(
          "div",
          { staticClass: "main-menu-items" },
          _vm._l(_vm.pkbMenu.highlightItems, function (item) {
            return _c("div", { staticClass: "menu-item-wrapper" }, [
              _c(
                "a",
                {
                  staticClass: "menu-item menu-item-main",
                  attrs: { href: item.path },
                },
                [_vm._v(_vm._s(item.label))]
              ),
            ])
          }),
          0
        ),
        _vm._l(_vm.pkbMenu.menuItems, function (item) {
          return _c("div", { staticClass: "menu-item-wrapper" }, [
            _c(
              "a",
              { staticClass: "menu-item", attrs: { href: item.path || null } },
              [_vm._v(_vm._s(item.label))]
            ),
            item.subMenuItems
              ? _c(
                  "div",
                  { staticClass: "submenu" },
                  _vm._l(item.subMenuItems, function (subItem) {
                    return _c(
                      "a",
                      {
                        staticClass: "submenu-item",
                        attrs: { href: subItem.path || null },
                      },
                      [_vm._v(_vm._s(subItem.label))]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
    _vm._m(0),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "f-row align-v-center logos",
        staticStyle: { gap: "10px" },
      },
      [
        _c(
          "a",
          {
            attrs: {
              href: "https://x.com/PanKbase",
              target: "_blank",
              title: "@PanKbase",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "https://hugeampkpncms.org/sites/default/files/images/logos/external/x-black.svg",
              },
            }),
          ]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://bsky.app/profile/pankbase.bsky.social",
              target: "_blank",
              title: "@pankbase.bsky.social",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "https://hugeampkpncms.org/sites/default/files/images/logos/external/bluesky-black.svg",
              },
            }),
          ]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.linkedin.com/groups/13199008/",
              target: "_blank",
              title: "LinkedIn",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "https://hugeampkpncms.org/sites/default/files/images/logos/external/linkedin-black.svg",
              },
            }),
          ]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://github.com/PanKbase",
              target: "_blank",
              title: "GitHub",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "https://hugeampkpncms.org/sites/default/files/images/logos/external/github-black.svg",
              },
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "f-row", staticStyle: { gap: "20px" } }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", {
          staticStyle: { height: "37px" },
          attrs: {
            src: "https://hugeampkpncms.org/sites/default/files/users/user32/pankbase/PanKbase_logo-black.svg",
          },
        }),
      ]),
      _c("div", [
        _vm._v(" Supported by "),
        _c("strong", [_vm._v("National Institutes of Health (NIH)")]),
        _vm._v(" grants "),
        _c("strong", [_vm._v("U24 DK138515")]),
        _vm._v(", "),
        _c("strong", [_vm._v("U24 DK138512")]),
        _c("br"),
        _vm._v(" Supplemental funds from the "),
        _c("strong", [_vm._v("NIH Office of Data Science Strategies")]),
      ]),
      _c(
        "a",
        { attrs: { href: "https://hirnetwork.org/", target: "_blank" } },
        [
          _c("img", {
            staticStyle: { height: "37px" },
            attrs: {
              src: "https://hugeampkpncms.org/sites/default/files/images/pankbase/logo-hirn.svg",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }